import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('block_attachment_download_segregation');
	},
};
